export enum NotStatus {
  READ = 'read',
  SHOW = 'show'
}

export type NotificationStatus = NotStatus | null

export interface Notification {
  id: string
  form_id: string
  category: string
  description: string
  type: 'image' | 'video' | null
  resource: string | null
  date: Date
  auto_show: boolean
  status: NotificationStatus
  url: string | null
  read_at: Date | null
}
